export default "__VITE_ASSET__BYQGi95B__"